import styled from 'styled-components';
import { compose, layout, LayoutProps, space, SpaceProps } from 'styled-system';

const SpacerSpan = styled.span<SpaceProps & Pick<LayoutProps, 'overflow' | 'width'>>(
  compose(layout, space)
);

export default SpacerSpan;
